import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchPlanTypes,
  createPlanType,
  updatePlanType,
  resetPlanTypeState
} from '../store/planTypeSlice';
import PlanTypeList from '../components/PlanTypeList';

const PlanTypeScreen = () => {
  const dispatch = useDispatch();
  const { planTypes, success } = useSelector((state) => state.planType);

  const [form, setForm] = useState({ plan_type: '' });
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    dispatch(fetchPlanTypes());
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      dispatch(resetPlanTypeState());
      setForm({ plan_type: '' });
      setEditingId(null);
    }
  }, [success, dispatch]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.plan_type.trim()) return;

    if (editingId) {
      dispatch(updatePlanType({ id: editingId, data: form }));
    } else {
      dispatch(createPlanType(form));
    }
  };

  const handleEdit = (planType) => {
    setForm({ plan_type: planType.plan_type });
    setEditingId(planType.id);
  };

  const handleCancel = () => {
    setForm({ plan_type: '' });
    setEditingId(null);
  };

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-bold mb-4">{editingId ? 'Edit Plan Type' : 'Add New Plan Type'}</h2>

      <form onSubmit={handleSubmit} className="flex items-center gap-4 mb-6">
        <input
          type="text"
          placeholder="Enter plan type"
          value={form.plan_type}
          onChange={(e) => setForm({ ...form, plan_type: e.target.value })}
          className="border px-4 py-2 rounded flex-1"
        />
        <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded">
          {editingId ? 'Update' : 'Create'}
        </button>
        {editingId && (
          <button
            type="button"
            onClick={handleCancel}
            className="bg-gray-500 text-white px-4 py-2 rounded"
          >
            Cancel
          </button>
        )}
      </form>

      <PlanTypeList planTypes={planTypes} onEdit={handleEdit} />
    </div>
  );
};

export default PlanTypeScreen;
